import { useFlags } from 'launchdarkly-react-client-sdk';

export const usePredictFlags = () => {
  const flags = useFlags();

  return {
    hasSwitchLocaleEnabled: !!flags?.switchLocale,
    hasHideExportToGoogleSheetsEnabled: !!flags?.hideExportToGoogleSheets,
    hasViewDownloadPdfOptionsEnabled: !!flags?.newViewDownloadPdfOptions
  };
};
